import Cookies from 'js-cookie';

(function($, window){
  
    $.fn.TimedPopup = function(options) {
      return this.each(function(){
        var settings = $.extend({
         cookieValue: 'sent-away',
         cookieNameAttr: 'data-timed-popup',
         closeSelector: '[data-timed-popup-close]',
         delaySelector: 'data-timed-popup-delay',
         delay: 0,
        }, options );
        
        var $popup = $(this);
        var cookieName = $popup.attr(settings.cookieNameAttr);
        var cookieVal = Cookies.get(cookieName);
        settings.delay = $popup.attr(settings.delaySelector)
        
        
        if(!cookieVal || cookieVal !== settings.cookieValue || options) {
          window.setTimeout(function(){
            
              $popup.addClass('timed-popup--ready');
              
              var id = $popup.attr('id');
              //MicroModal.show(id);
              window.setTimeout(function(){
                  $popup.addClass('timed-popup--visible');
                  var $popupSubmit = $popup.find("button[type=submit]");
                  var $popupInput = $popup.find("input[type=email]");
                  
                  $popupSubmit.attr('disabled', 'true'); //submit start disabled

                  $popup.on('change keyup', function(e) {
                    var $selectedValue = $popup.find("input[name='newsletter_marketing']:checked").val();

                    if($selectedValue === 'YES' && $popupInput.val() != '') {
                      $popupSubmit.removeAttr('disabled');
                    } else {
                      $popupSubmit.attr('disabled', 'true');
                    }
                  })
              }, 500);
          }, settings.delay);

          $(document).on('click', '[data-timed-popup-close]', function(){
            var date = new Date();
            var days = 7;
            date.setTime(date.getTime() + (days*24*60*60*1000));
            Cookies.set(cookieName, settings.cookieValue, { expires: date });
              $popup.removeClass('timed-popup--visible timed-popup--ready');                  
              //MicroModal.close(id);
          });
         }
      });
    }

  })(jQuery, window);
